(function() {
  'use strict';

  if (typeof window.GlLiveOpsEngine === 'undefined') {

    window.GlLiveOpsEngine = class {
      constructor(config) {
        this.config = config;
        this.UI = {};
        this.lastStateHash = null;
        this.pinState = null;
        this.PIN_STORAGE_KEY = 'gs_pin_check_v1';
        this.sectionId = config.sectionId;
        this.observerTimeout = null;
        this.pollTimer = null;
        this.observer = null;
        this.isUpdatingDOM = false;
        this.abortController = null;
        this.previousFocus = null;
        this._pollInFlight = false;
        this.POLL_MIN_MS = 300000;

        // Persistent Memory Authorization: Saves intervals into session memory slots to eliminate recursive re-fetch loops on route shifts
        this._pollCacheKey = 'gs_poll_cache_ok_' + this.sectionId;
        try {
          var cacheValue = sessionStorage.getItem(this._pollCacheKey);
          this._lastPollOk = cacheValue ? parseInt(cacheValue, 10) : 0;
        } catch(e) {
          this._lastPollOk = 0;
        }

        this._cachedConfigHash = null;
        this._onDocClick = null;
        this._barPaintedOnce = false;
        this._boundaryTimer = null;
        this._onGuard = null;

        // CLOCK-DRIFT SHIELD: if the device clock is wrong by >3 minutes,
        // correct against the server epoch rendered into the config. The 3-min
        // threshold means normal CDN cache staleness never triggers a false
        // correction, while a genuinely wrong clock (usually off by hours) does.
        this._clockOffsetMs = 0;
        try {
          if (config.serverEpoch) {
            var _drift = (Number(config.serverEpoch) * 1000) - Date.now();
            if (isFinite(_drift) && Math.abs(_drift) > 180000) this._clockOffsetMs = _drift;
          }
        } catch (e) {}

        this.render = this.render.bind(this);
        this.pollBackend = this.pollBackend.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.onPincodeChecked = this.onPincodeChecked.bind(this);
      }

      // FIX (critical): this helper was referenced everywhere but never defined,
      // causing a TypeError that aborted render() on product pages.
      createElement(tag, className, text) {
        const el = document.createElement(tag);
        if (className) el.className = className;
        if (text !== undefined && text !== null) el.textContent = text;
        return el;
      }

      registerPinApi() {
        const engine = this;
        window.updateGlPincode = function(status, cityContext, meta) {
          const live = window.glLiveOpsEngine || engine;
          if (live && typeof live.applyPinState === 'function') {
            live.applyPinState(status, cityContext, meta);
          }
        };
        window.updateGsPincode = window.updateGlPincode;
      }

      attachPinListeners() {
        if (this._pinListenerAttached) return;
        this._pinListenerAttached = true;
        document.addEventListener('gs:pincode-checked', this.onPincodeChecked);
      }

      onPincodeChecked(e) {
        const d = e && e.detail;
        if (!d || !d.pincode) return;
        this.applyPinState(d.serviceable !== false && d.geoServiceable !== false ? 'success' : 'fail', d.storeKey, d);
      }

      syncPinFromStorage() {
        try {
          const raw = localStorage.getItem(this.PIN_STORAGE_KEY);
          if (!raw) return;
          const saved = JSON.parse(raw);
          if (saved && saved.pincode && saved.status !== 'fail') {
            saved.geoServiceable = saved.geoServiceable !== false;
            saved.serviceable = saved.geoServiceable;
            saved.city = saved.city || this.getCityName(saved.storeKey);
            if (!this.pinState || this.pinState.pincode !== saved.pincode) {
              this.pinState = saved;
              this.lastStateHash = null;
            }
          }
        } catch (e) {}
      }

      getProductFormAnchors() {
        const selectors = [
          'form.hdt-main-product-form button[name="add"]',
          '.hdt-product-form__submit',
          '.hdt-product-form__buttons button[name="add"]',
          'hdt-buy-buttons button[name="add"]',
          'form button[name="add"]',
          '.product-form__buttons button[name="add"]',
          '.product-form__submit'
        ];
        const seen = new Set();
        const anchors = [];
        selectors.forEach(function(sel) {
          document.querySelectorAll(sel).forEach(function(btn) {
            if (btn.type !== 'submit' || seen.has(btn)) return;
            seen.add(btn);
            anchors.push(btn);
          });
        });
        return anchors;
      }

      getRenderHash(s) {
        const pinScenario = this.resolvePinScenario(s);
        const pinKey = (pinScenario.showMerged && this.pinState && this.pinState.pincode)
          ? `${pinScenario.mode}-${this.pinState.storeKey}-${this.pinState.pincode}`
          : (this.pinState ? `${this.pinState.status}-${this.pinState.storeKey}-${this.pinState.pincode || ''}` : 'null');
        return `${this.hashConfig(this.config)}|${s.isDelOpen}|${s.isRetOpen}|${pinKey}`;
      }

      paintBarState(s, ui) {
        if (!this.UI.bars || this.UI.bars.length === 0) return;
        this._barPaintedOnce = true;

        this.UI.bars.forEach(bar => {
          bar.setAttribute('data-status', ui.theme);
          bar.setAttribute('data-layout', ui.layoutOrder);
          if (ui.scene) bar.setAttribute('data-scene', ui.scene);
          else bar.removeAttribute('data-scene');

          if (ui.theme === 'open') {
            const retPill = bar.querySelector('.gl-badge-retail .gl-status-pill');
            if (retPill && retPill.className !== `gl-status-pill ${ui.pillClass}`) {
              retPill.className = `gl-status-pill ${ui.pillClass}`;
            }

            const delPill = bar.querySelector('.gl-badge-speed .gl-status-pill');
            if (delPill && delPill.className !== `gl-status-pill gl-del-pill ${ui.delPillClass}`) {
              delPill.className = `gl-status-pill gl-del-pill ${ui.delPillClass}`;
            }

            const delBadge = bar.querySelector('.gl-badge-speed');
            if (delBadge && delBadge.getAttribute('data-state') !== (s.isDelOpen ? 'open' : 'closed')) {
              delBadge.setAttribute('data-state', s.isDelOpen ? 'open' : 'closed');
            }
            const retBadge = bar.querySelector('.gl-badge-retail');
            if (retBadge && retBadge.getAttribute('data-state') !== (s.isRetOpen ? 'open' : 'closed')) {
              retBadge.setAttribute('data-state', s.isRetOpen ? 'open' : 'closed');
            }
          } else {
            const merged = bar.querySelector('.gl-pin-merged-ui, #gl-pin-merged');
            bar.removeAttribute('data-pin-mode');
            if (merged) merged.hidden = true;
          }
        });

        // FIX (perf): text/html setters iterate all bars internally, so they are
        // called once here instead of once per bar (was O(bars^2) writes).
        if (ui.theme === 'open') {
          this.setText('.gl-del-title-ui', ui.deliveryTitle);
          this.setHtml('.gl-city-txt-ui, #gl-city-txt', ui.cityMsgHtml || ui.cityMsg);
          this.setText('.gl-del-icon-ui', ui.delIcon);
          this.setText('.gl-lbl-ret-title', this.config.labels.retTitle);
          this.setHtml('.gl-retail-sub-ui, #gl-retail-sub', ui.retailMsgHtml || ui.retailMsg);
          this.setText('.gl-retail-icon', this.config.icons.ret);
          this.setHtml('.gl-pill-text-ui, #gl-pill-text', this.formatPillHtml(ui.pillText, ui.pillClass === 'closed'));
          this.setHtml('.gl-del-pill-text-ui, #gl-del-pill-text', this.formatPillHtml(ui.delPillText, ui.delPillClass === 'closed'));
        } else {
          this.setText('.gl-closed-txt-main-ui, #gl-closed-txt-main', ui.closedMsgMain);
          this.setText('.gl-closed-txt-sub-ui, #gl-closed-txt-sub', ui.closedMsgSub || '');
          this.setText('.gl-closed-master-icon', this.config.icons.closedMaster);
          this.setHtml('.gl-closed-stores-trust-ui, #gl-closed-stores-trust', this.getGlobalClosedTrustLineHtml());

          this.UI.bars.forEach(bar => {
            const cSub = bar.querySelector('.gl-closed-txt-sub-ui, #gl-closed-txt-sub');
            const metaRow = bar.querySelector('#gl-closed-meta-row');
            const trustEl = bar.querySelector('.gl-closed-stores-trust-ui, #gl-closed-stores-trust');
            if (cSub && metaRow) {
              cSub.style.display = ui.closedMsgSub ? 'inline' : 'none';
            }
            if (trustEl) {
              trustEl.style.display = trustEl.textContent.trim() ? 'block' : 'none';
            }
          });
        }

        this.setText('.gl-btn-txt-ui', this.config.labels.btnPin);
        this.setText('.gl-btn-icon-ui', this.config.icons.pin);
        this.setText('.gl-store-btn-txt', this.config.labels.btnStore);
        this.setText('.gl-store-btn-icon', this.config.icons.ret);
      }

      buildPinLocBlock(pin, city, showCity) {
        const pinHtml = '<span class="gl-qc-pin">' + pin + '</span>';
        if (showCity && city) {
          return '<span class="gl-qc-loc">' + pinHtml + '<span class="gl-qc-city">' + city + '</span></span>';
        }
        return '<span class="gl-qc-loc gl-qc-loc-pin-only">' + pinHtml + '</span>';
      }

      buildPinTrustBadgeMeta(scenario) {
        const lbl = this.config.msgs.pinTrustBadge || 'Verified';
        let cls = 'gl-qc-trust-badge';
        let text = lbl;
        if (scenario.mode === 'both_closed') {
          cls += ' gl-qc-trust-closed';
          text = 'Closed today';
        } else if (scenario.mode === 'del_closed_ret_open' || scenario.mode === 'del_pause') {
          cls += ' gl-qc-trust-warn';
        }
        const dotCls = scenario.mode === 'both_closed' ? 'gl-qc-trust-dot gl-qc-trust-dot-off' : 'gl-qc-trust-dot';
        return {
          cls: cls,
          html: '<span class="' + dotCls + '" aria-hidden="true"></span><span class="gl-qc-trust-txt">' + text + '</span>'
        };
      }

      buildStoreLocBlock(storeKey) {
        const city = this.getCityName(storeKey) || '';
        return '<span class="gl-qc-store-loc"><span class="gl-qc-store-name">Go Science</span><span class="gl-qc-store-city">' + city + '</span></span>';
      }

      buildPinTrustShort(scenario) {
        const html = this.buildPinTrustHtml(scenario);
        return String(html).replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
      }

      buildQcPinLines(scenario, s) {
        if (!this.pinState || !this.pinState.pincode) return { line1: '', line2: '' };
        const pin = this.pinState.pincode;
        const city = this.getCityName(this.pinState.storeKey) || this.pinState.city || '';
        const store = this.getStoreShort(this.pinState.storeKey);
        const times = this.getPinTimingStrings();
        const loc = this.buildPinLocBlock(pin, city, true);
        let line1 = '';
        let line2 = '';

        if (scenario.mode === 'full_open' || scenario.mode === 'del_open_ret_closed') {
          line1 = '<span class="gl-qc-em">' + this.ensureDeliveryAsterisk('Free 1–4 Hours') + '</span> <span class="gl-qc-tag">HOME DELIVERY</span><span class="gl-qc-dot-sep"> · </span><span class="gl-qc-to">to</span> ' + loc;
        } else if (scenario.mode === 'del_closed_ret_open') {
          line1 = '<span class="gl-qc-tag gl-qc-tag-warn">HOME DELIVERY CLOSED</span><span class="gl-qc-dot-sep"> · </span>' + loc;
        } else if (scenario.mode === 'del_pause') {
          line1 = '<span class="gl-qc-tag gl-qc-tag-warn">HOME DELIVERY PAUSED</span><span class="gl-qc-dot-sep"> · </span>' + loc;
        } else {
          line1 = '<span class="gl-qc-tag gl-qc-tag-closed">' + city + ' CLOSED TODAY</span><span class="gl-qc-dot-sep"> · </span>' + this.buildPinLocBlock(pin, city, false);
        }

        // FIX (perf): reuse the already-computed state when provided instead of
        // recomputing IST time and flags on every call.
        const stateRef = s || this.computeState();
        const storeRetOpen = this.isStoreRetOpen(this.pinState.storeKey, stateRef);
        if (storeRetOpen) {
          line2 = '<span class="gl-qc-em gl-qc-em-ret">VISIT STORE</span><span class="gl-qc-dot-sep"> · </span><span class="gl-qc-store">' + store + '</span><span class="gl-qc-dot-sep"> · </span><span class="gl-qc-open">Open</span><span class="gl-qc-dot-sep"> · </span><span class="gl-qc-shop">Shop at Store</span>';
        } else {
          line2 = '<span class="gl-qc-store">' + store + '</span><span class="gl-qc-dot-sep"> · </span><span class="gl-qc-closed">Closed · Opens ' + times.openRetStr + '</span>';
        }
        return { line1: line1, line2: line2 };
      }

      buildPdpQcBar(scenario) {
        const qc = this.buildQcPinLines(scenario);
        const referenceBar = document.querySelector('.gl-live-bar-class, #gl-live-bar');
        const mergedRef = referenceBar ? referenceBar.querySelector('.gl-pin-merged-ui, #gl-pin-merged') : null;
        const theme = mergedRef ? (mergedRef.getAttribute('data-qc-theme') || 'emerald_gold') : 'emerald_gold';
        const style = mergedRef ? (mergedRef.getAttribute('data-qc-style') || 'soft') : 'soft';

        const fragment = document.createDocumentFragment();
        const bar = this.createElement('div', 'gl-pdp-qc-bar gl-pin-merged gl-qc-bar gl-pin-merged-ui');
        bar.setAttribute('data-qc-theme', theme);
        bar.setAttribute('data-qc-style', style);

        const wrap = this.createElement('div', 'gl-qc-wrap');
        const cards = this.createElement('div', 'gl-qc-cards');

        const delCard = this.createElement('div', 'gl-qc-card gl-qc-card-del');
        const delInner = this.createElement('div', 'gl-qc-card-inner');
        const delIco = this.createElement('span', 'gl-qc-ico gl-qc-ico-del', '🚚');
        delIco.setAttribute('aria-hidden', 'true');
        const delBody = this.createElement('div', 'gl-qc-card-body');
        const delText = this.createElement('div', 'gl-qc-card-text gl-qc-card-text-del gl-pin-merged-title-ui');
        delText.innerHTML = qc.line1;
        const delActions = this.createElement('div', 'gl-qc-card-actions');
        delActions.appendChild(this.buildStackBtn(this.config.msgs.pinChangeLbl || 'Change pincode', ['Change', 'Pincode'], 'gl-qc-btn-stack gl-qc-btn-del gl-popup-trigger gs-popup-trigger gl-pin-change-btn-ui'));
        const clearBtn = this.createElement('button', 'gl-qc-clear-mini gl-pin-clear-trigger gl-pin-clear-btn-ui');
        clearBtn.type = 'button';
        clearBtn.setAttribute('aria-label', this.config.msgs.pinClearLbl || 'Clear pincode');
        clearBtn.textContent = this.getPinClearShort();
        delActions.appendChild(clearBtn);
        delBody.appendChild(delText);
        delBody.appendChild(delActions);
        delInner.appendChild(delIco);
        delInner.appendChild(delBody);
        delCard.appendChild(delInner);

        const retCard = this.createElement('div', 'gl-qc-card gl-qc-card-ret');
        const retInner = this.createElement('div', 'gl-qc-card-inner');
        const retIco = this.createElement('span', 'gl-qc-ico gl-qc-ico-ret', '🏪');
        retIco.setAttribute('aria-hidden', 'true');
        const retBody = this.createElement('div', 'gl-qc-card-body');
        const retText = this.createElement('div', 'gl-qc-card-text gl-qc-card-text-ret gl-pin-merged-sub-ui');
        retText.innerHTML = qc.line2;
        const retActions = this.createElement('div', 'gl-qc-card-actions');
        retActions.appendChild(this.buildStackBtn(this.config.msgs.pinStoreLbl || 'View store', ['View', 'Store'], 'gl-qc-btn-stack gl-qc-btn-ret gl-store-trigger gs-store-trigger gl-pin-store-btn-ui'));
        retBody.appendChild(retText);
        retBody.appendChild(retActions);
        retInner.appendChild(retIco);
        retInner.appendChild(retBody);
        retCard.appendChild(retInner);

        cards.appendChild(delCard);
        cards.appendChild(retCard);
        wrap.appendChild(cards);
        bar.appendChild(wrap);
        fragment.appendChild(bar);
        return fragment;
      }

      appendPinPdpCard(card, scenario) {
        card.classList.add('gl-pdp-default-card');
        card.classList.add('gl-pdp-qc-pin');
        card.classList.remove('gl-pdp-pin-card', 'is-warn', 'is-closed');
        card.setAttribute('data-pin-mode', scenario.barTheme || 'success');
        card.appendChild(this.buildPdpQcBar(scenario));
      }

      appendDefaultPdpCard(card, s, ui) {
        card.classList.add('gl-pdp-default-card');
        const shell = this.createElement('div', 'gl-pdp-default-shell');

        const delPane = this.createElement('div', 'gl-pdp-default-pane gl-pdp-default-pane-del' + (s.isDelOpen ? '' : ' is-closed') + ((s.isDelOpen && !s.isRetOpen) ? ' is-highlight' : ''));
        const delIco = this.createElement('div', 'gl-pdp-default-ico', ui.delIcon);
        delIco.setAttribute('aria-hidden', 'true');
        const delBody = this.createElement('div', 'gl-pdp-default-body');
        const delTitle = this.createElement('div', 'gl-pdp-default-title', this.ensureDeliveryAsterisk(ui.deliveryTitle));
        const delSub = this.createElement('div', 'gl-pdp-default-sub');
        delSub.innerHTML = ui.delSubHtml || ui.delSubText || ui.cityMsgHtml || ui.cityMsg || '';
        delBody.appendChild(delTitle);
        delBody.appendChild(delSub);
        const delBtn = this.createElement('button', 'gl-pdp-default-action gl-popup-trigger gs-popup-trigger', this.config.labels.btnPin);
        delBtn.type = 'button';
        delPane.appendChild(delIco);
        delPane.appendChild(delBody);
        delPane.appendChild(delBtn);

        const retPane = this.createElement('div', 'gl-pdp-default-pane gl-pdp-default-pane-ret' + (s.isRetOpen ? '' : ' is-closed') + ((!s.isDelOpen && s.isRetOpen) ? ' is-highlight' : ''));
        const retIco = this.createElement('div', 'gl-pdp-default-ico', this.config.icons.ret);
        retIco.setAttribute('aria-hidden', 'true');
        const retBody = this.createElement('div', 'gl-pdp-default-body');
        const retTitle = this.createElement('div', 'gl-pdp-default-title', this.config.labels.retTitle || 'Retail Stores');
        const retSub = this.createElement('div', 'gl-pdp-default-sub');
        if (s.isRetOpen) {
          retSub.innerHTML = ui.retSubHtml || ui.retSubText || ui.retailMsgHtml || ui.retailMsg || '';
        } else {
          retSub.innerHTML = ui.retSubHtml || ui.retSubText || ui.retailMsg || '';
        }
        retBody.appendChild(retTitle);
        retBody.appendChild(retSub);
        const retBtn = this.createElement('button', 'gl-pdp-default-action gl-store-trigger gs-store-trigger', this.config.labels.btnStore);
        retBtn.type = 'button';
        retPane.appendChild(retIco);
        retPane.appendChild(retBody);
        retPane.appendChild(retBtn);

        shell.appendChild(delPane);
        shell.appendChild(retPane);
        card.appendChild(shell);
      }

      appendClosedPdpCard(card, ui) {
        card.classList.add('closed-mode');
        const shell = this.createElement('div', 'gl-pdp-closed-shell');

        const statusCard = this.createElement('div', 'gl-pdp-closed-card');
        const iconWrap = this.createElement('div', 'gl-pdp-closed-icon', this.config.icons.closedMaster);
        iconWrap.setAttribute('aria-hidden', 'true');
        const copy = this.createElement('div', 'gl-pdp-closed-copy');
        const title = this.createElement('div', 'gl-pdp-closed-title gl-closed-txt-main-ui', ui.closedMsgMain || '');
        const meta = this.createElement('div', 'gl-pdp-closed-meta');
        const pill = this.createElement('span', 'gl-pdp-closed-pill');
        const pillDot = this.createElement('span', 'gl-pdp-closed-pill-dot');
        pillDot.setAttribute('aria-hidden', 'true');
        pill.appendChild(pillDot);
        pill.appendChild(document.createTextNode(' Closed'));
        meta.appendChild(pill);
        if (ui.closedMsgSub) {
          const sub = this.createElement('span', 'gl-pdp-closed-sub gl-closed-txt-sub-ui', ui.closedMsgSub);
          meta.appendChild(sub);
        }
        copy.appendChild(title);
        copy.appendChild(meta);
        const trustLine = this.getGlobalClosedTrustLineHtml();
        if (trustLine) {
          const trustEl = this.createElement('div', 'gl-pdp-closed-stores-trust gl-closed-stores-trust-ui');
          trustEl.innerHTML = trustLine;
          copy.appendChild(trustEl);
        }
        statusCard.appendChild(iconWrap);
        statusCard.appendChild(copy);

        const actions = this.createElement('div', 'gl-pdp-closed-actions');
        const pinBtn = this.createElement('button', 'gl-pdp-closed-btn gl-pdp-closed-btn-pin gl-popup-trigger gs-popup-trigger');
        pinBtn.type = 'button';
        pinBtn.setAttribute('aria-label', this.config.labels.btnPin);
        pinBtn.appendChild(document.createTextNode(this.config.icons.pin + ' '));
        pinBtn.appendChild(document.createTextNode(this.config.labels.btnPin));
        const storeBtn = this.createElement('button', 'gl-pdp-closed-btn gl-pdp-closed-btn-store gl-store-trigger gs-store-trigger');
        storeBtn.type = 'button';
        storeBtn.setAttribute('aria-label', this.config.labels.btnStore);
        storeBtn.appendChild(document.createTextNode(this.config.icons.ret + ' '));
        storeBtn.appendChild(document.createTextNode(this.config.labels.btnStore));
        actions.appendChild(pinBtn);
        actions.appendChild(storeBtn);

        shell.appendChild(statusCard);
        shell.appendChild(actions);
        card.appendChild(shell);
      }

      appendPinTrustCard(card, scenario) {
        this.appendPinPdpCard(card, scenario);
      }

      buildPdpPinData(scenario) {
        if (!this.pinState || !this.pinState.pincode) return null;
        const pin = this.pinState.pincode;
        const city = this.getCityName(this.pinState.storeKey) || this.pinState.city || '';
        const store = this.getStoreShort(this.pinState.storeKey);
        const times = this.getPinTimingStrings();
        const storeRetOpen = this.isStoreRetOpen(this.pinState.storeKey, this.computeState());
        let delBadge = null;
        let tone = 'ok';
        let delLabel = 'HOME DELIVERY';
        let showCityLine = true;

        if (scenario.mode === 'full_open' || scenario.mode === 'del_open_ret_closed') {
          delBadge = this.ensureDeliveryAsterisk('Free 1–4 Hrs');
          tone = 'ok';
          delLabel = 'HOME DELIVERY';
        } else if (scenario.mode === 'del_closed_ret_open') {
          tone = 'warn';
          delLabel = 'HOME DELIVERY CLOSED';
        } else if (scenario.mode === 'del_pause') {
          tone = 'warn';
          delLabel = 'HOME DELIVERY PAUSED';
        } else {
          tone = 'closed';
          delLabel = city + ' CLOSED TODAY';
          showCityLine = false;
        }

        return {
          tone: tone,
          delBadge: delBadge,
          delLabel: delLabel,
          pin: pin,
          city: showCityLine ? city : '',
          store: store,
          storeRetOpen: storeRetOpen,
          openRetStr: times.openRetStr,
          mode: scenario.mode
        };
      }

      getPdpPinBtnShort(label, fallback) {
        const txt = (label || '').trim() || fallback;
        const word = txt.split(/\s+/)[0] || fallback;
        return word.toUpperCase();
      }

      splitBtnLabel(label, fallback) {
        const txt = (label || '').trim() || fallback.join(' ');
        const words = txt.split(/\s+/).filter(Boolean);
        if (words.length <= 1) return [words[0] || fallback[0], fallback[1] || ''];
        if (words.length === 2) return [words[0], words[1]];
        return [words[0], words.slice(1).join(' ')];
      }

      setStackBtn(bar, selector, label, fallback) {
        const btn = bar ? bar.querySelector(selector) : null;
        if (!btn) return;
        const parts = this.splitBtnLabel(label, fallback);
        btn.innerHTML = '<span class="gl-btn-l1">' + parts[0] + '</span><span class="gl-btn-l2">' + parts[1] + '</span>';
      }

      buildStackBtn(label, fallback, className) {
        const parts = this.splitBtnLabel(label, fallback);
        const btn = this.createElement('button', className);
        btn.type = 'button';
        btn.innerHTML = '<span class="gl-btn-l1">' + parts[0] + '</span><span class="gl-btn-l2">' + parts[1] + '</span>';
        btn.setAttribute('aria-label', label || fallback.join(' '));
        return btn;
      }

      buildPinTrustHtml(scenario) {
        const m = this.config.msgs;
        const tpl = m.pinTrustLine || 'Shop <strong>in-store</strong> or <strong>online</strong> · Free 1–4 hr delivery*';
        if (scenario.mode === 'del_closed_ret_open' || scenario.mode === 'del_pause') {
          return 'Visit our store · Delivery paused for your pin right now';
        }
        if (scenario.mode === 'both_closed') {
          return 'Delivery & store closed today · Check back soon';
        }
        if (scenario.mode === 'del_open_ret_closed') {
          return 'Free 1–4 hr delivery* to your pin · Store opens later today';
        }
        return tpl;
      }

      hydratePinMeta(meta, storeKey) {
        meta = meta || {};
        if (meta.pincode) return meta;
        try {
          const raw = localStorage.getItem(this.PIN_STORAGE_KEY);
          if (raw) {
            const saved = JSON.parse(raw);
            if (saved && saved.pincode) return Object.assign({}, saved, meta);
          }
        } catch (e) {}
        if (this.pinState && this.pinState.pincode && (!storeKey || this.pinState.storeKey === storeKey)) {
          return Object.assign({}, this.pinState, meta);
        }
        return meta;
      }

      init() {
        try {
          this.registerPinApi();
          this.attachPinListeners();

          // Robust modal relocation: works no matter which wrapper the snippet
          // is rendered inside (previously only matched .hdt-header-inline).
          const anyModal = document.querySelector('.gl-store-modal-wrap');
          if (anyModal && anyModal.parentElement !== document.body) {
             document.querySelectorAll('body > .gl-store-modal-wrap').forEach(m => { if (m !== anyModal) m.remove(); });
             document.body.appendChild(anyModal);
          }

          this.cacheDOM();
          this.loadPinState();

          if (this.pinState && this.pinState.pincode) {
            const initialS = this.computeState();
            localStorage.setItem('gs_live_ops_status', !initialS.isDelOpen && !initialS.isRetOpen ? 'closed' : 'open');
            const initialScenario = this.resolvePinScenario(initialS);
            if (initialScenario && initialScenario.showMerged) {
              localStorage.setItem('gs_live_ops_pin_mode', initialScenario.barTheme);
            }
          }

          this.bindEvents();
          // PERF: observer catches late-injected forms — it can start in idle
          // time instead of competing with first paint. The capture-phase guard
          // (bound above, immediately) protects checkout during the gap.
          const idleInit = (cb) => (typeof window.requestIdleCallback === 'function')
            ? window.requestIdleCallback(cb, { timeout: 800 })
            : setTimeout(cb, 120);
          idleInit(() => { try { this.initObserver(); } catch (e) {} });

          this.render();
          this.startEventDrivenHydration();
          this.scheduleBoundaryTick();

          // PERF: this page's config was server-rendered moments ago — it IS
          // fresh. Skip the startup poll entirely; refocus handles stale tabs.
          if (!this._lastPollOk) {
            this._lastPollOk = Date.now();
            try { sessionStorage.setItem(this._pollCacheKey, this._lastPollOk); } catch (e) {}
          }

          // Anti-stuck failsafe: if any bar (e.g. a sticky-header clone whose
          // inline boot script never executed) is still "loading", force repaint.
          const failsafe = () => {
            try {
              this.cacheDOM();
              const hasBars = this.UI.bars && this.UI.bars.length > 0;
              const stuck = hasBars && this.UI.bars.some(function(b) { return b.getAttribute('data-status') === 'loading'; });
              if (hasBars && (stuck || !this._barPaintedOnce)) { this.lastStateHash = null; this.render(); }
            } catch (fe) {}
          };
          setTimeout(failsafe, 300);
          setTimeout(failsafe, 1200);

          if (this.pinState && this.pinState.pincode) {
            const self = this;
            setTimeout(function() { self.renderPinSideEffects(); if (self.UI.bars && self.UI.bars.length > 0) self.render(); }, 400);
            setTimeout(function() { self.renderPinSideEffects(); if (self.UI.bars && self.UI.bars.length > 0) self.render(); }, 1500);
          }

        } catch (e) {
          console.error("LiveOps Init Error:", e);
        }
      }

      renderPinSideEffects() {
        try {
          this.syncPinFromStorage();
          const s = this.computeState();
          const ui = this.deriveUI(s);
          const checkout = this.getCheckoutState(s, ui);
          const currentHash = this.getRenderHash(s);
          this.handleCheckoutButtons(checkout.blocked, checkout.btnMain, checkout.btnSub);
          this.updateTrustCards(s, ui, currentHash);
        } catch (e) {
          console.warn('GL PinSideEffects Error:', e);
        }
      }

      destroy() {
        if (this.observer) this.observer.disconnect();
        if (this.observerTimeout) clearTimeout(this.observerTimeout);
        if (this.abortController) this.abortController.abort();
        document.removeEventListener('keydown', this.handleKeydown);
        document.removeEventListener('gs:pincode-checked', this.onPincodeChecked);
        document.removeEventListener('visibilitychange', this.handleVisibilityChange);
        window.removeEventListener('focus', this.handleVisibilityChange);
        // FIX (leak): remove the delegated click handler so re-inits on
        // shopify:section:load don't stack duplicate listeners.
        if (this._onDocClick) {
          document.removeEventListener('click', this._onDocClick);
          this._onDocClick = null;
        }
        if (this._onGuard) {
          document.removeEventListener('click', this._onGuard, true);
          document.removeEventListener('submit', this._onGuard, true);
          this._onGuard = null;
        }
        clearTimeout(this._boundaryTimer);
        if (this.UI.storeModal && this.UI.storeModal.parentNode === document.body) {
           this.UI.storeModal.remove();
        }
        this._pinListenerAttached = false;
      }

      cacheDOM() {
        // COMPAT: match both the class-based markup and the legacy #gl-live-bar
        // markup, so a stale cached Liquid file can never leave the bar unpainted.
        const seenBars = new Set();
        const bars = [];
        document.querySelectorAll('.gl-live-bar-class, #gl-live-bar').forEach(function(b) {
          if (!seenBars.has(b)) { seenBars.add(b); bars.push(b); }
        });
        this.UI = {
          bars: bars,
          storeModal: document.querySelector('body > .gl-store-modal-wrap')
        };

        if (this.UI.storeModal) {
          this.UI.modalCh = this.UI.storeModal.querySelector('.gl-modal-ch-status');
          this.UI.modalCb = this.UI.storeModal.querySelector('.gl-modal-cb-status');
          this.UI.modalBl = this.UI.storeModal.querySelector('.gl-modal-bl-status');
        }
      }

      applyCityFlags(status) {
        let ch = false, cb = false, bl = false;
        switch (status) {
          case 'all_three_open':
            ch = cb = bl = true;
            break;
          case 'all_open':
          case 'chennai_coimbatore_only':
            ch = cb = true;
            break;
          case 'chennai_bengaluru_only':
            ch = bl = true;
            break;
          case 'coimbatore_bengaluru_only':
            cb = bl = true;
            break;
          case 'chennai_only':
            ch = true;
            break;
          case 'coimbatore_only':
            cb = true;
            break;
          case 'bengaluru_only':
            bl = true;
            break;
          default:
            ch = cb = bl = true;
        }
        return { chennai: ch, coimbatore: cb, bengaluru: bl };
      }

      resolveDelCityMsg(s) {
        return this.buildStoreListMsg(s.stores.del, 'delivery');
      }

      resolveRetCityMsg(s) {
        return this.buildStoreListMsg(s.stores.ret, 'retail');
      }

      resolveDelCityMsgHtml(s) {
        return this.buildStoreListMsgHtml(s.stores.del, 'delivery');
      }

      resolveRetCityMsgHtml(s) {
        return this.buildStoreListMsgHtml(s.stores.ret, 'retail');
      }

      countOpenStores(flags) {
        return ['chennai', 'coimbatore', 'bengaluru'].filter(function(k) { return flags[k]; }).length;
      }

      resolveScene(s) {
        if (this.pinState && this.pinState.pincode && this.pinState.status === 'fail') return 'pin-fail';
        if (!s.isDelOpen && s.isRetOpen) return 'del-closed-ret-open';
        if (s.isDelOpen && !s.isRetOpen) return 'del-open-ret-closed';
        let scene = 'both-open';
        const delOpen = this.countOpenStores(s.stores.del);
        const retOpen = this.countOpenStores(s.stores.ret);
        if (s.isDelOpen && delOpen > 0 && delOpen < 3) scene += ' partial-del';
        if (s.isRetOpen && retOpen > 0 && retOpen < 3) scene += ' partial-ret';
        return scene.trim();
      }

      escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;');
      }

      formatOrderedCitiesHtml(keys, asOpen) {
        const labels = { chennai: 'Chennai', coimbatore: 'Coimbatore', bengaluru: 'Bengaluru' };
        const cls = asOpen ? 'gl-hl-open-city' : 'gl-hl-closed-city';
        const names = keys.map(function(k) {
          const lbl = labels[k];
          if (!lbl) return '';
          return '<span class="' + cls + '">' + lbl + '</span>';
        }).filter(Boolean);
        if (names.length === 0) return '';
        if (names.length === 1) return names[0];
        if (names.length === 2) return names[0] + ' <span class="gl-hl-sep">&amp;</span> ' + names[1];
        return names.slice(0, -1).join('<span class="gl-hl-sep">, </span>') + ' <span class="gl-hl-sep">&amp;</span> ' + names[names.length - 1];
      }

      highlightStatusWords(html) {
        if (!html || html.indexOf('<') === -1) {
          html = this.escapeHtml(html);
        }
        return String(html)
          .replace(/\bActive\b/g, '<span class="gl-hl-active-word">Active</span>')
          .replace(/\bOpen\b/g, '<span class="gl-hl-open-word">Open</span>')
          .replace(/\bClosed\b/g, '<span class="gl-hl-closed-word">Closed</span>');
      }

      formatPillHtml(text, isClosed) {
        const t = String(text || '');
        if (isClosed) return this.escapeHtml(t);
        if (/^active$/i.test(t.trim())) return '<span class="gl-hl-active-word">' + this.escapeHtml(t) + '</span>';
        if (/^open$/i.test(t.trim())) return '<span class="gl-hl-open-word">' + this.escapeHtml(t) + '</span>';
        return this.escapeHtml(t);
      }

      buildStoreListMsgHtml(flags, mode) {
        const order = this.getStoreOrder();
        const openKeys = order.filter(function(k) { return flags[k]; });
        const closedKeys = order.filter(function(k) { return !flags[k]; });
        const openHtml = this.formatOrderedCitiesHtml(openKeys, true);
        const closedHtml = this.formatOrderedCitiesHtml(closedKeys, false);
        const m = this.config.msgs;
        let html = '';

        if (openKeys.length === 0) {
          html = this.escapeHtml(mode === 'delivery' ? m.delClosedMaster : m.retClosedMaster);
          return this.highlightStatusWords(html);
        }
        if (openKeys.length === 3) {
          const tpl = mode === 'delivery'
            ? (m.delAllThreeTpl || m.delOpenAllThree || 'Active Now in {cities}')
            : (m.retAllThreeTpl || m.retOpenAllThree || 'Go Science {cities} Open');
          html = this.fillTemplate(tpl, { cities: openHtml });
          return this.highlightStatusWords(html);
        }
        if (openKeys.length === 2) {
          const tpl = mode === 'delivery'
            ? (m.delTwoOpenTpl || 'Active in {open} • {closed} Closed')
            : (m.retTwoOpenTpl || 'Go Science {open} Open • {closed} Closed');
          html = this.fillTemplate(tpl, { open: openHtml, closed: closedHtml });
          return this.highlightStatusWords(html);
        }
        if (openKeys.length === 1) {
          const tpl = mode === 'delivery'
            ? (m.delOneOpenTpl || 'Active in {open} • {closed} Closed')
            : (m.retOneOpenTpl || '{open} Open • {closed} Closed');
          html = this.fillTemplate(tpl, { open: openHtml, closed: closedHtml });
          return this.highlightStatusWords(html);
        }
        html = this.escapeHtml(mode === 'delivery' ? m.delClosedMaster : m.retClosedMaster);
        return this.highlightStatusWords(html);
      }

      resolvePinFailCopy() {
        const m = this.config.msgs;
        const pin = (this.pinState && this.pinState.pincode) ? String(this.pinState.pincode) : '';
        const title = m.pinFailTitle || 'Pincode Non-Serviceable';
        const sk = (this.pinState && this.pinState.storeKey) || '';
        const city = (this.pinState && this.pinState.city) || '';
        const pinWord = pin || 'the pincode you\'ve entered';
        const failDefaults = {
          sub: 'Delivery not available to the pincode you\'ve entered',
          ch: 'Delivery not available to pincode {pincode}. Please visit Go Science Chennai.',
          cb: 'Delivery not available to pincode {pincode}. Please visit Go Science Coimbatore.',
          bl: 'Delivery not available to pincode {pincode}. Please visit Go Science Bengaluru.'
        };
        let subTpl = m.pinFailSub || m.pinFail || failDefaults.sub;
        if (sk === 'chennai' || city === 'Chennai') subTpl = m.pinFailCh || failDefaults.ch;
        else if (sk === 'coimbatore' || city === 'Coimbatore') subTpl = m.pinFailCb || failDefaults.cb;
        else if (sk === 'bengaluru' || city === 'Bengaluru') subTpl = m.pinFailBl || failDefaults.bl;
        let sub = this.fillTemplate(subTpl, { pincode: pinWord, city: city });
        sub = this.ensureDeliveryAsterisk(sub);
        let subHtml = this.escapeHtml(sub);
        if (pin) {
          subHtml = subHtml.split(pin).join('<span class="gl-hl-pin-code">' + pin + '</span>');
        }
        return { title: title, sub: sub, subHtml: subHtml };
      }

      getStoreOrder() {
        const raw = this.config.storeOrder || ['chennai', 'coimbatore', 'bengaluru'];
        const seen = {};
        const order = [];
        raw.forEach(function(k) {
          if (k && !seen[k]) { seen[k] = true; order.push(k); }
        });
        ['chennai', 'coimbatore', 'bengaluru'].forEach(function(k) {
          if (!seen[k]) order.push(k);
        });
        return order;
      }

      isGlobalClosed(s) {
        s = s || this.computeState();
        return !s.isDelOpen && !s.isRetOpen;
      }

      getGlobalClosedTrustLine() {
        return this.ensureDeliveryAsterisk(
          'Retail stores in Bengaluru, Chennai & Coimbatore with Free 1–4* Hour Home Delivery'
        );
      }

      getGlobalClosedTrustLineHtml() {
        return '<span class="gl-closed-trust-line1">Retail stores in ' +
          '<span class="gl-closed-trust-city">Bengaluru</span>, ' +
          '<span class="gl-closed-trust-city">Chennai</span> & ' +
          '<span class="gl-closed-trust-city">Coimbatore</span></span>' +
          '<span class="gl-closed-trust-line2">' +
          '<span class="gl-closed-trust-del">Free 1–4* Hour Home Delivery</span></span>';
      }

      formatOrderedCities(keys) {
        const labels = { chennai: 'Chennai', coimbatore: 'Coimbatore', bengaluru: 'Bengaluru' };
        const names = keys.map(function(k) { return labels[k]; }).filter(Boolean);
        if (names.length === 0) return '';
        if (names.length === 1) return names[0];
        if (names.length === 2) return names[0] + ' & ' + names[1];
        return names.slice(0, -1).join(', ') + ' & ' + names[names.length - 1];
      }

      buildStoreListMsg(flags, mode) {
        const order = this.getStoreOrder();
        const openKeys = order.filter(function(k) { return flags[k]; });
        const closedKeys = order.filter(function(k) { return !flags[k]; });
        const openC = this.formatOrderedCities(openKeys);
        const closedC = this.formatOrderedCities(closedKeys);
        const m = this.config.msgs;

        if (openKeys.length === 0) {
          return mode === 'delivery' ? m.delClosedMaster : m.retClosedMaster;
        }
        if (openKeys.length === 3) {
          const tpl = mode === 'delivery'
            ? (m.delAllThreeTpl || m.delOpenAllThree || 'Active Now in {cities}')
            : (m.retAllThreeTpl || m.retOpenAllThree || 'Go Science {cities} Open');
          return this.fillTemplate(tpl, { cities: openC });
        }
        if (openKeys.length === 2) {
          const tpl = mode === 'delivery'
            ? (m.delTwoOpenTpl || 'Active in {open} • {closed} Closed')
            : (m.retTwoOpenTpl || 'Go Science {open} Open • {closed} Closed');
          return this.fillTemplate(tpl, { open: openC, closed: closedC });
        }
        if (openKeys.length === 1) {
          const tpl = mode === 'delivery'
            ? (m.delOneOpenTpl || 'Active in {open} • {closed} Closed')
            : (m.retOneOpenTpl || '{open} Open • {closed} Closed');
          return this.fillTemplate(tpl, { open: openC, closed: closedC });
        }
        return mode === 'delivery' ? m.delClosedMaster : m.retClosedMaster;
      }

      ensureDeliveryAsterisk(text) {
        if (!text) return text;
        return String(text)
          .replace(/1\s*[\-–]\s*4(?!\*)/gi, '1–4*')
          .replace(/1\s+to\s+4(?!\*)/gi, '1 to 4*');
      }

      getIST() {
        // Timezone Resolution Fix: Enforcing formatting rules strips out variations across device clock regions
        var baseNow = new Date(Date.now() + (this._clockOffsetMs || 0));
        try {
          var parts = new Intl.DateTimeFormat('en-US', {
            timeZone: 'Asia/Kolkata', hour: '2-digit', minute: '2-digit', hour12: false
          }).formatToParts(baseNow);
          var h = parseInt(parts.find(function(p) { return p.type === 'hour'; }).value, 10);
          var m = parseInt(parts.find(function(p) { return p.type === 'minute'; }).value, 10);
          if (h === 24) h = 0; // Some engines report midnight as 24 with hour12:false
          return {
            getHours: function() { return h; },
            getMinutes: function() { return m; }
          };
        } catch(e) {
          var d = baseNow;
          var utc = d.getTime() + (d.getTimezoneOffset() * 60000);
          var ist = new Date(utc + (330 * 60000));
          return {
            getHours: function() { return ist.getHours(); },
            getMinutes: function() { return ist.getMinutes(); }
          };
        }
      }

      formatTime(h, m) {
        let p = h >= 12 ? 'PM' : 'AM';
        h = h % 12 || 12;
        return `${h}:${m < 10 ? '0'+m : m} ${p}`;
      }

      getStoreShort(storeKey) {
        const map = {
          chennai: 'Go Science Chennai',
          coimbatore: 'Go Science Coimbatore',
          bengaluru: 'Go Science Bengaluru'
        };
        return map[storeKey] || 'Go Science Store';
      }

      getStoreLabel(storeKey) {
        const map = {
          chennai: 'Go Science Chennai - T.Nagar Store',
          coimbatore: 'Go Science Coimbatore - RS Puram Store',
          bengaluru: 'Go Science Bengaluru - HSR Store'
        };
        return map[storeKey] || 'Go Science Store';
      }

      fillTemplate(tpl, vars) {
        return (tpl || '')
          .replace(/\{pincode\}/g, vars.pincode || '')
          .replace(/\{store\}/g, vars.store || '')
          .replace(/\{city\}/g, vars.city || '')
          .replace(/\{cities\}/g, vars.cities || '')
          .replace(/\{open\}/g, vars.open || '')
          .replace(/\{closed\}/g, vars.closed || '')
          .replace(/\{time\}/g, vars.time || '');
      }

      isStoreDelOpen(storeKey, s) {
        return !!(s && s.stores && s.stores.del && s.stores.del[storeKey]);
      }

      isStoreRetOpen(storeKey, s) {
        return !!(s && s.stores && s.stores.ret && s.stores.ret[storeKey]);
      }

      getPinTimingStrings() {
        return {
          openDelStr: this.formatTime(this.config.hours.del.open.h, this.config.hours.del.open.m),
          openRetStr: this.formatTime(this.config.hours.ret.open.h, this.config.hours.ret.open.m)
        };
      }

      buildPinRetailLine(store, isOpen, retailLbl, openTime) {
        const storeHl = '<strong class="gl-pin-store-hl">' + store + '</strong>';
        if (isOpen) {
          return '<span class="gl-pin-ret-green">🏢 ' + retailLbl + '</span> · ' + storeHl + ' · Open';
        }
        return storeHl + ' · Closed · Opens ' + openTime;
      }

      resolvePinScenario(s, pinState) {
        pinState = pinState || this.pinState;
        const empty = {
          mode: 'none', showMerged: false, icon: '⚡', titleClass: 'gl-pin-title-open',
          dotColor: 'var(--gl-dot-open)', title: '', subHtml: '', checkoutBlocked: false, barTheme: 'default'
        };
        if (!pinState || !pinState.pincode) return empty;

        if (!s.isDelOpen && !s.isRetOpen) return empty;

        const geoOk = pinState.geoServiceable !== false && pinState.serviceable !== false && pinState.status !== 'fail';
        if (!geoOk) return empty;

        const m = this.config.msgs;
        const retailLbl = m.pdpRetailLabel || 'Retail Store';
        const storeKey = pinState.storeKey;
        const store = this.getStoreShort(storeKey);
        const city = this.getCityName(storeKey) || pinState.city || '';
        const times = this.getPinTimingStrings();
        const vars = { pincode: pinState.pincode, store: store, city: city, time: times.openDelStr };
        const storeDelOpen = this.isStoreDelOpen(storeKey, s);
        const storeRetOpen = this.isStoreRetOpen(storeKey, s);

        if (this.config.qCommMode === 'force_short') {
          vars.time = times.openDelStr;
          return {
            mode: 'del_pause',
            showMerged: true,
            icon: this.config.icons.delClosed,
            titleClass: 'gl-pin-title-closed',
            dotColor: 'var(--gl-dot-closed)',
            title: this.fillTemplate(m.pinDelPauseTitle || 'Delivery paused for {city} · Pin {pincode}', vars),
            subHtml: this.buildPinRetailLine(store, storeRetOpen, retailLbl, times.openRetStr),
            checkoutBlocked: true,
            barTheme: 'del-closed'
          };
        }

        if (storeDelOpen && storeRetOpen) {
          const titleTpl = m.pinSuccessTitle || 'Free 1–4* Hour Delivery to {pincode} · {city}';
          return {
            mode: 'full_open',
            showMerged: true,
            icon: this.config.icons.delOpen,
            titleClass: 'gl-pin-title-open',
            dotColor: 'var(--gl-dot-open)',
            title: this.ensureDeliveryAsterisk(this.fillTemplate(titleTpl, vars)),
            subHtml: this.buildPinRetailLine(store, true, retailLbl, times.openRetStr),
            checkoutBlocked: false,
            barTheme: 'success'
          };
        }

        if (!storeDelOpen && storeRetOpen) {
          vars.time = times.openDelStr;
          return {
            mode: 'del_closed_ret_open',
            showMerged: true,
            icon: this.config.icons.delClosed,
            titleClass: 'gl-pin-title-closed',
            dotColor: 'var(--gl-dot-closed)',
            title: this.fillTemplate(m.pinDelClosedTitle || 'Delivery closed for {city} · Pin {pincode}', vars),
            subHtml: this.buildPinRetailLine(store, true, retailLbl, times.openRetStr),
            checkoutBlocked: true,
            barTheme: 'del-closed'
          };
        }

        if (storeDelOpen && !storeRetOpen) {
          const titleTpl = m.pinSuccessTitle || 'Free 1–4* Hour Delivery to {pincode} · {city}';
          vars.time = times.openRetStr;
          return {
            mode: 'del_open_ret_closed',
            showMerged: true,
            icon: this.config.icons.delOpen,
            titleClass: 'gl-pin-title-open',
            dotColor: 'var(--gl-dot-open)',
            title: this.ensureDeliveryAsterisk(this.fillTemplate(titleTpl, vars)),
            subHtml: this.buildPinRetailLine(store, false, retailLbl, times.openRetStr),
            checkoutBlocked: false,
            barTheme: 'success'
          };
        }

        vars.time = times.openDelStr;
        return {
          mode: 'both_closed',
          showMerged: true,
          icon: this.config.icons.closedMaster,
          titleClass: 'gl-pin-title-closed',
          dotColor: 'var(--gl-dot-closed)',
          title: this.fillTemplate(m.pinStoreClosedTitle || '{city} store closed today · Pin {pincode}', vars),
          subHtml: this.fillTemplate(m.pinStoreClosedSub || 'Delivery & in-store unavailable · Opens {time}', vars),
          checkoutBlocked: true,
          barTheme: 'both-closed'
        };
      }

      getCheckoutState(s, ui) {
        const scenario = this.resolvePinScenario(s);
        if (scenario.showMerged) {
          let btnMain = ui.btnMainText;
          let btnSub = ui.btnSubMsg;
          if (scenario.checkoutBlocked) {
            if (scenario.mode === 'del_pause') {
              btnMain = this.config.msgs.delPause;
              btnSub = this.config.labels.subDelPause;
            } else if (scenario.mode === 'del_closed_ret_open') {
              btnMain = this.config.msgs.delClosedMaster;
              btnSub = this.config.labels.subDelClosedRetOpen;
            } else if (scenario.mode === 'both_closed') {
              btnMain = this.config.labels.btnBothClosed;
              btnSub = (this.config.labels.subBothClosed || '').replace('{time}', this.getPinTimingStrings().openRetStr);
            } else {
              btnMain = this.config.msgs.delClosedMaster;
              btnSub = ui.btnSubMsg;
            }
          }
          return { blocked: scenario.checkoutBlocked, btnMain: btnMain, btnSub: btnSub };
        }
        return { blocked: !s.isDelOpen, btnMain: ui.btnMainText, btnSub: ui.btnSubMsg };
      }

      buildPinMergedCopy(s) {
        const scenario = this.resolvePinScenario(s);
        return {
          title: scenario.title,
          sub: scenario.subHtml,
          subHtml: scenario.subHtml,
          scenario: scenario
        };
      }

      savePinState() {
        try {
          if (this.pinState && this.pinState.pincode && this.pinState.geoServiceable !== false && this.pinState.status !== 'fail') {
            localStorage.setItem(this.PIN_STORAGE_KEY, JSON.stringify(this.pinState));
            // FIX: only cache a pin mode the boot script/CSS actually understands.
            // Previously 'default' could be cached (e.g. while globally closed),
            // making the boot script hide badges with nothing to show.
            const scenario = this.resolvePinScenario(this.computeState());
            if (scenario && scenario.showMerged && scenario.barTheme && scenario.barTheme !== 'default') {
              localStorage.setItem('gs_live_ops_pin_mode', scenario.barTheme);
            } else {
              localStorage.removeItem('gs_live_ops_pin_mode');
            }
          } else {
            localStorage.removeItem(this.PIN_STORAGE_KEY);
            localStorage.removeItem('gs_live_ops_pin_mode');
          }
          sessionStorage.removeItem(this.PIN_STORAGE_KEY);
        } catch (e) {}
      }

      loadPinState() {
        try {
          let raw = localStorage.getItem(this.PIN_STORAGE_KEY);
          if (!raw) {
            raw = sessionStorage.getItem(this.PIN_STORAGE_KEY);
            if (raw) {
              localStorage.setItem(this.PIN_STORAGE_KEY, raw);
              sessionStorage.removeItem(this.PIN_STORAGE_KEY);
            }
          }
          if (!raw) return;
          const saved = JSON.parse(raw);
          if (saved && saved.pincode && saved.status !== 'fail') {
            delete saved.phase;
            saved.city = saved.city || this.getCityName(saved.storeKey);
            saved.geoServiceable = saved.geoServiceable !== false;
            saved.serviceable = saved.geoServiceable;
            this.pinState = saved;
          }
        } catch (e) {}
      }

      clearPinState() {
        this.pinState = null;
        this.savePinState();
        this.lastStateHash = null;
        try {
          window.dispatchEvent(new CustomEvent('gs:pincode-cleared'));
        } catch (e) {}
        if (this.UI.bars && this.UI.bars.length > 0) {
          this.render();
        } else {
          this.renderPinSideEffects();
        }
      }

      getCityName(storeKey) {
        const map = { chennai: 'Chennai', coimbatore: 'Coimbatore', bengaluru: 'Bengaluru' };
        return map[storeKey] || '';
      }

      applyPinState(status, cityContext, meta) {
        meta = meta || {};
        const storeKey = cityContext || meta.storeKey || 'unknown';
        meta = this.hydratePinMeta(meta, storeKey);
        const geoServiceable = meta.geoServiceable !== undefined ? meta.geoServiceable : (status === 'success');
        if (!meta.pincode) return;
        this.pinState = {
          status: status,
          city: meta.city || this.getCityName(storeKey) || storeKey,
          storeKey: storeKey,
          pincode: meta.pincode,
          storeName: meta.storeName || this.getStoreLabel(storeKey),
          serviceable: geoServiceable,
          geoServiceable: geoServiceable
        };
        this.savePinState();
        this.lastStateHash = null;
        if (this.UI.bars && this.UI.bars.length > 0) {
          this.render();
        } else {
          this.renderPinSideEffects();
        }
      }

      getPinClearShort() {
        const lbl = (this.config.msgs.pinClearLbl || 'Clear pincode').trim();
        const first = lbl.split(/\s+/)[0] || 'clear';
        return first.toLowerCase();
      }

      renderPinMerged(s) {
        if (!this.UI.bars || this.UI.bars.length === 0) return;

        this.UI.bars.forEach(bar => {
          const merged = bar.querySelector('.gl-pin-merged-ui, #gl-pin-merged');
          if (this.isGlobalClosed(s)) {
            bar.removeAttribute('data-pin-mode');
            if (merged) merged.hidden = true;
            return;
          }

          const scenario = this.resolvePinScenario(s);
          if (!scenario.showMerged) {
            bar.removeAttribute('data-pin-mode');
            if (merged) merged.hidden = true;
            return;
          }

          bar.setAttribute('data-pin-mode', scenario.barTheme);
          if (scenario.barTheme !== 'both-closed') {
            bar.setAttribute('data-status', 'open');
          }

          const qc = this.buildQcPinLines(scenario, s);

          // FIX: line1 contains HTML markup — using setText rendered the raw
          // <span> tags as literal text in the header pin card.
          this.setHtml('.gl-pin-merged-title-ui, #gl-pin-merged-title', qc.line1);
          this.setHtml('.gl-pin-merged-sub-ui, #gl-pin-merged-sub', qc.line2);

          this.setStackBtn(bar, '.gl-pin-change-btn-ui, #gl-pin-change-btn', this.config.msgs.pinChangeLbl || 'Change pincode', ['Change', 'Pincode']);

          var clearBtn = bar.querySelector('.gl-pin-clear-btn-ui, #gl-pin-clear-btn'); if (clearBtn) clearBtn.textContent = this.getPinClearShort();

          this.setStackBtn(bar, '.gl-pin-store-btn-ui, #gl-pin-store-btn', this.config.msgs.pinStoreLbl || 'View store', ['View', 'Store']);
          if (merged) merged.hidden = false;
        });
      }

      hashConfig(c) {
        if (this._cachedConfigHash && c === this.config) {
          return this._cachedConfigHash;
        }
        // serverEpoch is a per-render timestamp — exclude it so it never
        // masquerades as a "config change" and forces needless re-renders.
        var c2 = c;
        if (c && c.serverEpoch !== undefined) {
          c2 = Object.assign({}, c);
          delete c2.serverEpoch;
        }
        var signature = JSON.stringify(c2);
        if (c === this.config) {
          this._cachedConfigHash = signature;
        }
        return signature;
      }

      computeState() {
        const ist = this.getIST();
        const nowM = ist.getHours() * 60 + ist.getMinutes();

        const delStartM = this.config.hours.del.open.h * 60 + this.config.hours.del.open.m;
        const delEndM = this.config.hours.del.close.h * 60 + this.config.hours.del.close.m;
        const isDelTimeOpen = nowM >= delStartM && nowM < delEndM;

        const retStartM = this.config.hours.ret.open.h * 60 + this.config.hours.ret.open.m;
        const retEndM = this.config.hours.ret.close.h * 60 + this.config.hours.ret.close.m;
        const isRetTimeOpen = nowM >= retStartM && nowM < retEndM;

        const qCommStatus = this.config.qCommMode === 'auto' ? isDelTimeOpen : this.config.qCommMode === 'force_open';
        const retailStatus = this.config.retailMode === 'auto' ? isRetTimeOpen : this.config.retailMode === 'force_open';

        let chDel = false, cbDel = false, blDel = false, chRet = false, cbRet = false, blRet = false;

        if (qCommStatus && !['force_close', 'force_short'].includes(this.config.qCommMode)) {
          const delFlags = this.applyCityFlags(this.config.cityStatusOnline);
          chDel = delFlags.chennai;
          cbDel = delFlags.coimbatore;
          blDel = delFlags.bengaluru;
        }

        if (retailStatus && !['force_close', 'holiday'].includes(this.config.retailMode)) {
          const retFlags = this.applyCityFlags(this.config.cityStatusRetail);
          chRet = retFlags.chennai;
          cbRet = retFlags.coimbatore;
          blRet = retFlags.bengaluru;
        }

        return {
          isDelOpen: (chDel || cbDel || blDel),
          isRetOpen: (chRet || cbRet || blRet),
          stores: {
            del: { chennai: chDel, coimbatore: cbDel, bengaluru: blDel },
            ret: { chennai: chRet, coimbatore: cbRet, bengaluru: blRet }
          }
        };
      }

      deriveUI(s) {
        let theme, layoutOrder, cityMsg, retailMsg, cityMsgHtml, retailMsgHtml, delSubHtml, retSubHtml, pillText, pillClass, delPillText, delPillClass, closedMsgMain, closedMsgSub, deliveryTitle, delIcon, btnSubMsg, btnMainText, delSubText, retSubText;
        const openDelStr = this.formatTime(this.config.hours.del.open.h, this.config.hours.del.open.m);
        const openRetStr = this.formatTime(this.config.hours.ret.open.h, this.config.hours.ret.open.m);

        if (!s.isRetOpen) {
          if (this.config.retailMode === 'holiday') {
             retailMsg = this.config.msgs.retHoliday;
             retSubText = this.config.msgs.retHoliday;
          } else if (this.config.retailMode === 'force_close') {
             retailMsg = this.config.msgs.retClosedMaster;
             retSubText = this.config.msgs.retClosedMaster;
          } else {
             retailMsg = this.config.msgs.retClosedMaster;
             retSubText = (this.config.labels.subRetClosedAuto || "").replace('{time}', openRetStr);
          }
          retailMsgHtml = this.highlightStatusWords(this.escapeHtml(retSubText));
          retSubHtml = retailMsgHtml;
          pillText = this.config.labels.pillClosed;
          pillClass = "closed";
        } else {
          pillText = this.config.labels.pillOpen;
          pillClass = "";
          retailMsg = this.resolveRetCityMsg(s);
          retailMsgHtml = this.resolveRetCityMsgHtml(s);
          retSubText = retailMsg;
          retSubHtml = retailMsgHtml;
        }

        if (!s.isDelOpen) {
          delIcon = this.config.icons.delClosed;
          delPillText = this.config.labels.pillClosed;
          delPillClass = "closed";

          if (this.config.qCommMode === 'force_short') {
             delSubText = this.config.labels.subDelPause;
          } else if (this.config.qCommMode === 'force_close') {
             delSubText = this.config.msgs.delClosedMaster;
          } else {
             delSubText = (this.config.labels.subDelClosedAuto || "").replace('{time}', openDelStr);
          }

          if (this.config.qCommMode === 'force_short') {
             btnMainText = this.config.msgs.delPause;
             deliveryTitle = this.config.msgs.delPause;
             btnSubMsg = this.config.labels.subDelPause;
          } else if (s.isRetOpen) {
             btnMainText = this.config.msgs.delClosedMaster;
             deliveryTitle = this.config.msgs.delClosedMaster;
             btnSubMsg = this.config.labels.subDelClosedRetOpen;
          } else {
             btnMainText = this.config.labels.btnBothClosed;
             deliveryTitle = this.config.msgs.delClosedMaster;
             btnSubMsg = (this.config.labels.subBothClosed || "").replace('{time}', openDelStr);
          }
          cityMsg = delSubText;
          cityMsgHtml = this.highlightStatusWords(this.escapeHtml(delSubText));
          delSubHtml = cityMsgHtml;
        } else {
          deliveryTitle = this.ensureDeliveryAsterisk(this.config.msgs.delETA);
          delIcon = this.config.icons.delOpen;
          delPillText = this.config.labels.pillActive || 'Active';
          delPillClass = "";
          cityMsg = this.resolveDelCityMsg(s);
          cityMsgHtml = this.resolveDelCityMsgHtml(s);
          delSubText = cityMsg;
          delSubHtml = cityMsgHtml;
          btnMainText = "";
          btnSubMsg = "";
        }

        if (this.pinState && this.pinState.pincode && this.pinState.geoServiceable !== false && this.pinState.status !== 'fail') {
          /* merged bar handles per-store pin UI via resolvePinScenario */
        } else if (this.pinState && this.pinState.status === 'fail') {
            const fail = this.resolvePinFailCopy();
            deliveryTitle = fail.title;
            cityMsg = fail.sub;
            delSubText = fail.sub;
            cityMsgHtml = fail.subHtml;
            delSubHtml = fail.subHtml;
            delIcon = this.config.icons.delClosed;
            delPillText = this.config.labels.pillClosed;
            delPillClass = 'closed';
        }

        if (!s.isDelOpen && s.isRetOpen) {
          layoutOrder = 'retail-first';
          theme = 'open';
        } else if (!s.isDelOpen && !s.isRetOpen) {
          layoutOrder = 'delivery-first';
          theme = 'closed';
          closedMsgMain = this.config.msgs.bothClosedMaster;
          if (this.config.qCommMode === 'auto' && this.config.retailMode === 'auto') {
             closedMsgSub = `Opens ${openRetStr}`;
          }
        } else {
          layoutOrder = 'delivery-first';
          theme = 'open';
        }

        return { theme, layoutOrder, scene: this.resolveScene(s), cityMsg, cityMsgHtml, retailMsg, retailMsgHtml, delSubHtml, retSubHtml, pillText, pillClass, delPillText, delPillClass, closedMsgMain, closedMsgSub, deliveryTitle, delIcon, btnSubMsg, btnMainText, delSubText, retSubText };
      }

      handleCheckoutButtons(isClosed, btnMainText, btnSubMsg) {
        try {
          const buttons = document.querySelectorAll('button[name="add"], .product-form__submit, .shopify-payment-button__button, .hdt-main-cart__button-checkout, .hdt-mini-cart__btn-checkout, #smsalert_checkout_btn, .cart__submit');

          buttons.forEach(btn => {
            if (isClosed) {
              if (!btn.hasAttribute('data-gl-html')) {
                  btn.setAttribute('data-gl-html', btn.innerHTML);
                  // FIX: remember whether the theme had already disabled this
                  // button (e.g. sold out) so we don't wrongly re-enable it later.
                  btn.setAttribute('data-gl-was-disabled', btn.disabled ? 'true' : 'false');
              }

              if (btn.getAttribute('data-gl-disabled-state') === 'true' &&
                  btn.getAttribute('data-gl-main-text') === btnMainText &&
                  btn.getAttribute('data-gl-sub-text') === (btnSubMsg || '')) {
                return;
              }
              btn.setAttribute('data-gl-disabled-state', 'true');
              btn.setAttribute('data-gl-main-text', btnMainText);
              btn.setAttribute('data-gl-sub-text', btnSubMsg || '');

              const fragment = document.createDocumentFragment();
              const spanMain = document.createElement('span');
              spanMain.className = 'gl-btn-main-text';
              spanMain.textContent = btnMainText;
              fragment.appendChild(spanMain);

              if (btnSubMsg) {
                  const spanSub = document.createElement('span');
                  spanSub.className = 'gl-btn-sub-text';
                  spanSub.textContent = btnSubMsg;
                  fragment.appendChild(spanSub);
              }

              btn.innerHTML = '';
              btn.appendChild(fragment);

              btn.disabled = true;
              btn.setAttribute('aria-disabled', 'true');
              btn.classList.add('gl-disabled-btn');

            } else {
              // Only restore buttons this engine actually modified. Never touch
              // buttons we didn't disable (e.g. theme's own sold-out state).
              if (!btn.hasAttribute('data-gl-html') && !btn.hasAttribute('data-gl-disabled-state')) return;
              btn.removeAttribute('data-gl-disabled-state');
              btn.removeAttribute('data-gl-main-text');
              btn.removeAttribute('data-gl-sub-text');
              const wasDisabled = btn.getAttribute('data-gl-was-disabled') === 'true';
              btn.removeAttribute('data-gl-was-disabled');
              if (btn.hasAttribute('data-gl-html')) {
                btn.innerHTML = btn.getAttribute('data-gl-html');
                btn.removeAttribute('data-gl-html');
              }
              btn.disabled = wasDisabled;
              if (wasDisabled) {
                btn.setAttribute('aria-disabled', 'true');
              } else {
                btn.removeAttribute('aria-disabled');
              }
              btn.classList.remove('gl-disabled-btn');
            }
          });
        } catch (e) {}
      }

      // Universal Parameter Signature Fix: Methods refactored to sweep cleanly across multiple layout blocks natively
      setText(selector, text) {
        if (text === undefined || text === null || !this.UI.bars) return;
        this.UI.bars.forEach(bar => {
          bar.querySelectorAll(selector).forEach(el => {
            // PERF: expando cache — compare against last-written value instead
            // of reading the live DOM; zero serialization, zero attribute noise.
            if (el.__glLastText === text) return;
            el.textContent = text;
            el.__glLastText = text;
          });
        });
      }

      setHtml(selector, html) {
        if (html === undefined || html === null || !this.UI.bars) return;
        this.UI.bars.forEach(bar => {
          bar.querySelectorAll(selector).forEach(el => {
            if (el.__glLastHtml === html) return;
            el.innerHTML = html;
            el.__glLastHtml = html;
          });
        });
      }

      initObserver() {
        const observeConfig = { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] };
        this.isUpdatingDOM = false;

        this.observer = new MutationObserver((mutations) => {
          if (this.isUpdatingDOM) return;

          let shouldTrigger = false;
          for (let m of mutations) {
            if (m.type === 'childList' && m.addedNodes.length > 0) {
              shouldTrigger = Array.from(m.addedNodes).some(n => {
                 if (n.nodeType !== 1) return false;
                 const tag = n.tagName;
                 if (tag === 'BUTTON' || tag === 'FORM' || tag === 'HDT-BUY-BUTTONS' || tag === 'A') return true;
                 return (n.classList && (n.classList.contains('product-form__submit') || n.classList.contains('gl-disabled-btn') || n.classList.contains('gl-trust-card'))) || (n.querySelector && n.querySelector('button[name="add"]'));
              });
              if(shouldTrigger) break;
            } else if (m.type === 'attributes') {
                if (m.target.tagName !== 'BUTTON') continue;
                if (m.target.getAttribute('data-gl-disabled-state') === 'true') continue;
                if (m.target.classList && m.target.classList.contains('gl-disabled-btn')) continue;
                shouldTrigger = true; break;
            }
          }

          if (!shouldTrigger) return;

          // RACE-WINDOW FIX: when the store is CLOSED, the checkout lock is
          // re-applied SYNCHRONOUSLY the instant new/changed buttons appear —
          // no 150ms gap in which a freshly swapped variant button sits enabled.
          try {
            const sNow = this.computeState();
            const uiNow = this.deriveUI(sNow);
            const coNow = this.getCheckoutState(sNow, uiNow);
            if (coNow.blocked) {
              this.observer.disconnect();
              this.isUpdatingDOM = true;
              this.handleCheckoutButtons(true, coNow.btnMain, coNow.btnSub);
              requestAnimationFrame(() => {
                this.attachObserverToContainers(observeConfig);
                this.isUpdatingDOM = false;
              });
            }
          } catch (lockErr) {}

          // FIX (perf): debounce is reserved for SECONDARY work (trust cards,
          // button restores) so mutation bursts run it at most once per 150ms.
          if (this.observerTimeout) clearTimeout(this.observerTimeout);
          this.observerTimeout = setTimeout(() => {
            if (this.isUpdatingDOM || !this.observer) return;

            // Observer Loop Isolation: Disconnect tracking pipelines forcefully before firing dynamic node write runs
            this.observer.disconnect();
            this.isUpdatingDOM = true;

            try {
              this.syncPinFromStorage();
              const s = this.computeState();
              const ui = this.deriveUI(s);
              const checkout = this.getCheckoutState(s, ui);

              this.handleCheckoutButtons(checkout.blocked, checkout.btnMain, checkout.btnSub);
              this.updateTrustCards(s, ui, this.getRenderHash(s));
            } catch (err) {
              console.warn('GL Observer Update Error:', err);
            }

            requestAnimationFrame(() => {
               this.attachObserverToContainers(observeConfig);
               this.isUpdatingDOM = false;
            });
          }, 150);
        });

        this.attachObserverToContainers(observeConfig);
      }

      attachObserverToContainers(config) {
         if (!this.observer) return;
         // PERF: observe only product forms + the live bars (from the original
         // engine) instead of the whole document.body — far fewer callbacks.
         const roots = [];
         const seen = new Set();
         document.querySelectorAll('form.hdt-main-product-form, .product-form, hdt-buy-buttons, form[action*="/cart/add"]').forEach(function(w) {
           if (!seen.has(w)) { seen.add(w); roots.push(w); }
         });
         (this.UI.bars || []).forEach(function(b) { if (!seen.has(b)) { seen.add(b); roots.push(b); } });
         if (roots.length === 0) {
           this.observer.observe(document.body, config);
           return;
         }
         roots.forEach(w => this.observer.observe(w, config));
      }

      render() {
        try {
          this.syncPinFromStorage();
          const s = this.computeState();
          const ui = this.deriveUI(s);
          const currentHash = this.getRenderHash(s);
          const checkout = this.getCheckoutState(s, ui);

          if (this.observer) this.observer.disconnect();
          this.isUpdatingDOM = true;

          if (!this.UI.bars || this.UI.bars.length === 0) {
            this.cacheDOM();
          }

          // CRITICAL ORDERING FIX: paint the header bar FIRST and in isolation.
          // Previously trust-card/checkout code ran before the bar paint, so any
          // product-page error left the top bar stuck/unrendered.
          if (this.UI.bars && this.UI.bars.length > 0) {
            const isLoading = this.UI.bars.some(function(b) { return b.getAttribute('data-status') === 'loading'; });
            if (this.lastStateHash !== currentHash || isLoading) {
              try {
                this.paintBarState(s, ui);
                this.lastStateHash = currentHash;
                localStorage.setItem('gs_live_ops_status', !s.isDelOpen && !s.isRetOpen ? 'closed' : 'open');
              } catch (barErr) {
                console.warn('GL Bar Paint Error:', barErr);
              }
            }
            try { this.renderPinMerged(s); } catch (pinErr) { console.warn('GL Pin Paint Error:', pinErr); }
          }

          const runSecondary = () => {
            try {
              this.handleCheckoutButtons(checkout.blocked, checkout.btnMain, checkout.btnSub);
            } catch (btnErr) { console.warn('GL Checkout Btn Error:', btnErr); }
            try {
              this.updateTrustCards(s, ui, currentHash);
            } catch (tcErr) { console.warn('GL Trust Card Error:', tcErr); }
          };
          if (checkout.blocked) {
            runSecondary(); // business-critical: disable checkout NOW
          } else {
            // PERF: nothing needs disabling — yield to the browser first so the
            // page paints/scrolls instantly, then do the secondary DOM work.
            if (typeof window.requestIdleCallback === 'function') {
              window.requestIdleCallback(runSecondary, { timeout: 400 });
            } else {
              setTimeout(runSecondary, 40);
            }
          }

          const openRetStr = this.formatTime(this.config.hours.ret.open.h, this.config.hours.ret.open.m);
          let chStatus = s.stores.ret.chennai ? this.config.labels.pillOpen : this.config.labels.pillClosed;
          let cbStatus = s.stores.ret.coimbatore ? this.config.labels.pillOpen : this.config.labels.pillClosed;
          let blStatus = s.stores.ret.bengaluru ? this.config.labels.pillOpen : this.config.labels.pillClosed;

          if (this.config.retailMode === 'auto' && !s.isRetOpen) {
              const timeStr = `Opens ${openRetStr}`;
              if (!s.stores.ret.chennai) chStatus = `${chStatus} • ${timeStr}`;
              if (!s.stores.ret.coimbatore) cbStatus = `${cbStatus} • ${timeStr}`;
              if (!s.stores.ret.bengaluru) blStatus = `${blStatus} • ${timeStr}`;
          }

          if(this.UI.modalCh && this.UI.modalCh.textContent !== chStatus) {
            this.UI.modalCh.textContent = chStatus;
            this.UI.modalCh.className = `gl-sc-status ${s.stores.ret.chennai ? 'open' : 'closed'}`;
          }
          if(this.UI.modalCb && this.UI.modalCb.textContent !== cbStatus) {
            this.UI.modalCb.textContent = cbStatus;
            this.UI.modalCb.className = `gl-sc-status ${s.stores.ret.coimbatore ? 'open' : 'closed'}`;
          }
          if(this.UI.modalBl && this.UI.modalBl.textContent !== blStatus) {
            this.UI.modalBl.textContent = blStatus;
            this.UI.modalBl.className = `gl-sc-status ${s.stores.ret.bengaluru ? 'open' : 'closed'}`;
          }

          requestAnimationFrame(() => {
            this.attachObserverToContainers({ childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });
            this.isUpdatingDOM = false;
          });
        } catch (e) {
          console.warn("GL Render Error:", e);
          this.isUpdatingDOM = false;
        }
      }

      updateTrustCards(s, ui, currentHash) {
        this.syncPinFromStorage();
        const anchors = this.getProductFormAnchors();
        anchors.forEach(btn => {
          const container = btn.closest('form') || btn.closest('hdt-buy-buttons') || btn.parentNode;
          if (!container) return;
          let card = container.querySelector('.gl-trust-card');

          if (!card) {
            card = document.createElement('div');
            card.className = 'gl-trust-card';
            container.insertBefore(card, btn.nextSibling);
          }

          const livePin = this.pinState && this.pinState.pincode ? this.pinState.pincode : '';

          if (card.dataset.glKey === currentHash && card.dataset.glPin === livePin) return;
          card.dataset.glKey = currentHash;
          card.dataset.glPin = livePin;
          card.style.display = 'block';
          card.innerHTML = '';
          card.classList.remove('gl-qc-pdp-card', 'gl-pdp-pin-card', 'gl-pdp-qc-pin', 'gl-pdp-default-card', 'gl-pdp-pin-fail', 'closed-mode', 'is-warn', 'is-closed');

          if (!s.isDelOpen && !s.isRetOpen && !(this.pinState && this.resolvePinScenario(s).showMerged)) {
             this.appendClosedPdpCard(card, ui);
          } else {
             const pinScenario = this.pinState && this.pinState.pincode ? this.resolvePinScenario(s) : null;

             if (pinScenario && pinScenario.showMerged) {
               this.appendPinPdpCard(card, pinScenario);
             } else {
               if (this.pinState && this.pinState.pincode && this.pinState.status === 'fail') {
                 card.classList.add('gl-pdp-pin-fail');
               }
               this.appendDefaultPdpCard(card, s, ui);
             }
          }
        });
      }

      openModal() {
        if(this.UI.storeModal) {
           this.UI.storeModal.style.display = 'flex';
           this.UI.storeModal.setAttribute('aria-hidden', 'false');
           this.previousFocus = document.activeElement;
           const closeBtn = this.UI.storeModal.querySelector('.gl-sc-close');
           if (closeBtn) closeBtn.focus();
        }
      }

      closeModal() {
        if(this.UI.storeModal) {
           this.UI.storeModal.style.display = 'none';
           this.UI.storeModal.setAttribute('aria-hidden', 'true');
           if (this.previousFocus) this.previousFocus.focus();
        }
      }

      handleKeydown(e) {
        if (e.key === 'Escape' && this.UI.storeModal && this.UI.storeModal.getAttribute('aria-hidden') === 'false') {
          this.closeModal();
        }
      }

      // PERF+CORRECTNESS: compute ms until the next open/close boundary (IST).
      // Replaces every-minute polling — zero network, one timer, exact timing.
      getNextBoundaryDelayMs() {
        try {
          const ist = this.getIST();
          const nowM = ist.getHours() * 60 + ist.getMinutes();
          const h = this.config.hours;
          const marks = [h.del.open, h.del.close, h.ret.open, h.ret.close]
            .map(function(t) { return (t.h * 60 + t.m); })
            .sort(function(a, b) { return a - b; });
          let nextM = null;
          for (let i = 0; i < marks.length; i++) {
            if (marks[i] > nowM) { nextM = marks[i]; break; }
          }
          if (nextM === null) nextM = marks[0] + 24 * 60; // first boundary tomorrow
          const delayMs = (nextM - nowM) * 60000 + 5000;  // +5s past the minute
          return Math.max(5000, Math.min(delayMs, 6 * 3600000)); // clamp 5s..6h
        } catch (e) { return 60000; }
      }

      scheduleBoundaryTick() {
        clearTimeout(this._boundaryTimer);
        this._boundaryTimer = setTimeout(() => {
          try { this.render(); } catch (e) {}
          this.scheduleBoundaryTick();
        }, this.getNextBoundaryDelayMs());
      }

      startEventDrivenHydration() {
          this.handleVisibilityChange = () => {
              if (document.visibilityState === 'visible') {
                  try { this.render(); } catch (e) {}   // instant local re-check (open/close boundary)
                  this.scheduleBoundaryTick();
                  if (document.hasFocus()) this.pollBackend();
              }
          };

          document.addEventListener('visibilitychange', this.handleVisibilityChange);
          window.addEventListener('focus', this.handleVisibilityChange);

      }

      bindEvents() {
        // AIRTIGHT CHECKOUT ENFORCEMENT (capture phase): re-verify live state at
        // the moment of click/submit. A button left enabled past closing time
        // can never actually fire — the business rule holds regardless of timers.
        if (this._onGuard) {
          document.removeEventListener('click', this._onGuard, true);
          document.removeEventListener('submit', this._onGuard, true);
        }
        this._onGuard = e => {
          try {
            const t = e.target;
            const btn = (t && t.closest) ? t.closest('button[name="add"], .product-form__submit, .shopify-payment-button__button, .hdt-main-cart__button-checkout, .hdt-mini-cart__btn-checkout, #smsalert_checkout_btn, .cart__submit, a[href*="/checkout"]') : null;
            const isCartSubmit = e.type === 'submit' && t && t.matches && (t.matches('form[action*="/cart/add"]') || t.matches('form[action*="/cart"]'));
            if (!btn && !isCartSubmit) return;
            const s = this.computeState();
            const ui = this.deriveUI(s);
            const checkout = this.getCheckoutState(s, ui);
            if (checkout.blocked) {
              e.preventDefault();
              e.stopPropagation();
              this.lastStateHash = null;
              this.render(); // repaint everything to the closed state immediately
            }
          } catch (err) {}
        };
        document.addEventListener('click', this._onGuard, true);
        document.addEventListener('submit', this._onGuard, true);

        // FIX (leak): keep a reference so destroy() can remove this listener.
        if (this._onDocClick) document.removeEventListener('click', this._onDocClick);
        this._onDocClick = e => {
          const clearTrigger = e.target.closest('.gl-pin-clear-trigger, #gl-pin-clear-btn');
          if (clearTrigger) {
            e.preventDefault();
            e.stopPropagation();
            this.clearPinState();
            return;
          }

          const storeTrigger = e.target.closest('.gl-store-trigger, .gs-store-trigger');
          if (storeTrigger) {
            if (storeTrigger.tagName === 'BUTTON') e.preventDefault();
            e.stopPropagation();
            this.openModal();
            return;
          }

          const pinTrigger = e.target.closest('.gl-popup-trigger, .gs-popup-trigger');
          if (pinTrigger) {
            if (pinTrigger.closest('#gl-pin-merged')) return;

            const isTopBarBtn = pinTrigger.closest('.gl-badge-speed') && pinTrigger.closest('.gl-live-bar-class');

            if (!isTopBarBtn) {
               e.stopPropagation();
               e.preventDefault();
               const mainPinBtn = document.querySelector('.gl-live-bar-class .gl-badge-speed .gl-popup-trigger');
               if (mainPinBtn) {
                  mainPinBtn.click();
               }
            }
          }

          if (this.UI.storeModal && (e.target === this.UI.storeModal || e.target.closest('.gl-sc-close'))) {
            this.closeModal();
          }
        };
        document.addEventListener('click', this._onDocClick);

        document.addEventListener('keydown', this.handleKeydown);
      }

      pollBackend(force) {
        if (window.Shopify && Shopify.designMode) return;

        var now = Date.now();
        var minGap = this.POLL_MIN_MS || 300000;
        if (!force && this._lastPollOk && (now - this._lastPollOk) < minGap) return;
        if (this._pollInFlight) return;
        this._pollInFlight = true;

        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        const url = root + '?sections=' + encodeURIComponent(this.sectionId);

        fetch(url, { signal: this.abortController.signal })
          .then(res => {
            try {
              const dh = res.headers && res.headers.get ? res.headers.get('date') : null;
              if (dh) {
                const drift = new Date(dh).getTime() - Date.now();
                this._clockOffsetMs = (isFinite(drift) && Math.abs(drift) > 180000) ? drift : 0;
              }
            } catch (e) {}
            return res.json();
          })
          .then(data => {
            const html = data[this.sectionId];
            if (!html) return;

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const targetConfigEl = doc.getElementById('gl-config-data');
            if (!targetConfigEl) return;

            // Core Cache Reset: Clear current cache signatures when customizer parameters update
            const newConfig = JSON.parse(targetConfigEl.textContent);
            if (this.hashConfig(this.config) !== JSON.stringify(newConfig)) {
              this._cachedConfigHash = null;
              this.config = newConfig;
              this.lastStateHash = null;
              this.loadPinState();
              this.render();
              this.scheduleBoundaryTick();
            }
            this._lastPollOk = Date.now();
            try {
              sessionStorage.setItem(this._pollCacheKey, this._lastPollOk);
            } catch(e) {}
          })
          .catch(err => {
             if (err.name !== 'AbortError') console.warn('GL Sync Skipped');
          })
          .finally(function() {
            this._pollInFlight = false;
          }.bind(this));
      }
    };

  }

  function clearGlSessionCache(configStr) {
    try {
      var cached = sessionStorage.getItem('gl_live_config_str');
      if (cached !== configStr) {
        sessionStorage.removeItem('gl_live_bar_html');
        sessionStorage.removeItem('gl_live_bar_status');
        sessionStorage.removeItem('gl_live_bar_layout');
        sessionStorage.setItem('gl_live_config_str', configStr);
      }
    } catch (e) {}
  }

  function initLiveOps() {
    const configDataEl = document.getElementById('gl-config-data');
    if (!configDataEl) return;

    try {
      const configStr = configDataEl.textContent;
      clearGlSessionCache(configStr);
      const config = JSON.parse(configStr);
      if (window.glLiveOpsEngine) {
        if (window.glLiveOpsEngine.destroy) window.glLiveOpsEngine.destroy();
      }
      window.glLiveOpsEngine = new window.GlLiveOpsEngine(config);
      window.glLiveOpsEngine.lastStateHash = null;
      window.glLiveOpsEngine.init();
    } catch (e) {
      console.error("LiveOps Initialization Failed:", e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLiveOps);
  } else {
    initLiveOps();
  }

  document.addEventListener('shopify:section:load', function(event) {
    const sectionLoaded = event.target.querySelector('.gl-live-bar-class');
    if (event.detail.sectionId === window.glLiveOpsEngine?.sectionId || sectionLoaded) {
      initLiveOps();
    }
  });
})();